export default __webpack_public_path__ + "images/5E.27b6cba.png";